'use client';

import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n, { getStoredLanguage } from '@/i18n';

function syncHtmlLang() {
  const lang = i18n.language?.split('-')[0] || 'en';
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lang === 'zh' ? 'zh-CN' : 'en';
  }
}

export default function I18nProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    const stored = getStoredLanguage();
    if (stored !== i18n.language?.split('-')[0]) {
      i18n.changeLanguage(stored);
    }
    syncHtmlLang();
    i18n.on('languageChanged', syncHtmlLang);
    return () => i18n.off('languageChanged', syncHtmlLang);
  }, []);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
